export default {
  // 获取区域或板块数据
  getAreas(level) {
    let that = this;
    return new Promise((resolve, reject) => {
      that.$axios.get(that.$url_prefix + 'queryAreaByLevel', {
        params: {
          level: level,
          projection: '-_id id area_name district dots old_price new_price center hot sum_data'
        }
      }).then(function (res) {
        // 确保返回数组，防止null/undefined
        resolve(res.data.data || []);
      }).catch((err) => {
        console.error('getAreas error:', err);
        // 错误时返回空数组而不是reject，避免后续代码报错
        resolve([]);
      });
    });
  },

  // 计算两点距离
  getClosestDot(a, b) {
    let lista = a.split("-");
    let listb = b.split("-");
    let dota = lista[0].split("|");
    let dotb = listb[0].split("|");
    let distance = AMap.GeometryUtil.distance(dota, dotb);
    for (let i = 0; i < lista.length; i++) {
      for (let j = 0; j < listb.length; j++) {
        let pointa = lista[i].split("|");
        let pointb = listb[j].split("|");
        let temp = AMap.GeometryUtil.distance(pointa, pointb);
        if (temp < distance) {
          distance = temp;
          dota = pointa;
          dotb = pointb;
        }
      }
    }
    return {
      a: dota,
      b: dotb,
      distance: distance,
    };
  },

  // 计算卡片合适位置，使用边界贴靠策略
  calculateCardPosition(realPos, index, total, placedCards = [], cardDimensions = null, allDotPositions = []) {
    // 使用智能边界贴靠位置分配
    let smartPosition = this.calculateSmartPosition(realPos, index, total, allDotPositions, cardDimensions);

    console.log(`卡片 ${index} 边界贴靠策略，放置在 ${smartPosition.boundary} 边界，偏移量: (${smartPosition.x.toFixed(4)}, ${smartPosition.y.toFixed(4)})`);

    // 直接返回边界贴靠的结果，不进行任何调整
    return { x: smartPosition.x, y: smartPosition.y };
  },

  // 智能位置分配：真正的边界贴靠策略
  calculateSmartPosition(realPos, index, total, allDotPositions, cardDimensions) {
    const lng = parseFloat(realPos[0]);
    const lat = parseFloat(realPos[1]);

    // 初始化边界计数器（如果不存在）
    if (!this.borderCardCounts) {
      this.borderCardCounts = { right: 0, bottom: 0, left: 0, top: 0 };
    }

    // 使用高德地图API获取当前地图视窗的真实边界
    let mapBounds;
    try {
      const currentMap = this.$refs.make_map.$$getInstance();
      const bounds = currentMap.getBounds();
      mapBounds = {
        minLng: bounds.southwest.lng,
        maxLng: bounds.northeast.lng,
        minLat: bounds.southwest.lat,
        maxLat: bounds.northeast.lat
      };
      console.log('使用高德地图API获取的边界:', mapBounds);
    } catch (error) {
      console.warn('无法获取地图边界，使用备用计算方式:', error);
      // 备用方案：基于所有圆点计算边界
      let minLng = lng, maxLng = lng, minLat = lat, maxLat = lat;
      if (allDotPositions && allDotPositions.length > 0) {
        allDotPositions.forEach(pos => {
          const posLng = parseFloat(pos.lng || pos[0]);
          const posLat = parseFloat(pos.lat || pos[1]);
          if (posLng < minLng) minLng = posLng;
          if (posLng > maxLng) maxLng = posLng;
          if (posLat < minLat) minLat = posLat;
          if (posLat > maxLat) maxLat = posLat;
        });
      }

      const padding = 0.02;
      mapBounds = {
        minLng: minLng - padding,
        maxLng: maxLng + padding,
        minLat: minLat - padding,
        maxLat: maxLat + padding
      };
    }

    // 卡片尺寸和边界设置
    const pixelToLngLat = 0.0001; // 像素到经纬度转换系数（减小以让卡片更贴近边界）
    let cardWidthOffset, cardHeightOffset;

    if (cardDimensions) {
      // 基于实际卡片尺寸计算偏移量
      cardWidthOffset = (cardDimensions.width / 2) * pixelToLngLat;
      cardHeightOffset = (cardDimensions.height / 2) * pixelToLngLat;
      console.log(`卡片 ${index} 实际尺寸: ${cardDimensions.width}x${cardDimensions.height}px, 偏移量: ${cardWidthOffset.toFixed(6)}, ${cardHeightOffset.toFixed(6)}`);
    } else {
      // 使用默认值作为后备
      cardWidthOffset = 0.035;
      cardHeightOffset = 0.030;
      console.log(`卡片 ${index} 使用默认偏移量: ${cardWidthOffset}, ${cardHeightOffset}`);
    }

    const borderMargin = 0.0;     // 边界间距（减小以让卡片更贴近边界）
    // 优化边界容量分配：优先考虑距离，而不是严格平均分配
    // 对于少量卡片，允许更灵活的分配
    let maxCardsPerBorder;
    if (total <= 4) {
      maxCardsPerBorder = total; // 少量卡片时，每个边界都可以容纳所有卡片
    } else {
      maxCardsPerBorder = Math.ceil(total / 3); // 使用3个边界分配，留一个边界作为备用
    }

    console.log(`总卡片数: ${total}, 每边界最大容量: ${maxCardsPerBorder}`);

    // 1. 计算圆点到四条边界的距离
    const distances = {
      right: mapBounds.maxLng - lng,
      bottom: lat - mapBounds.minLat,
      left: lng - mapBounds.minLng,
      top: mapBounds.maxLat - lat
    };

    // 2. 按距离排序，得到边界优先级
    const borderPriority = Object.keys(distances)
      .sort((a, b) => distances[a] - distances[b]);

    console.log(`卡片 ${index} 边界距离:`, distances);
    console.log(`边界优先级:`, borderPriority);

    // 3-5. 智能边界选择：综合考虑距离和负载
    let selectedBorder = null;

    // 首先尝试选择距离最近且未满的边界
    for (const border of borderPriority) {
      if (this.borderCardCounts[border] < maxCardsPerBorder) {
        selectedBorder = border;
        break;
      }
    }

    // 如果所有边界都满了，使用加权评分系统
    if (!selectedBorder) {
      let bestScore = Infinity;
      let bestBorder = borderPriority[0];

      for (const border of borderPriority) {
        // 计算综合评分：距离权重70% + 负载权重30%
        const distanceScore = distances[border];
        const loadScore = this.borderCardCounts[border] / maxCardsPerBorder;
        const totalScore = distanceScore * 0.7 + loadScore * 0.3;

        if (totalScore < bestScore) {
          bestScore = totalScore;
          bestBorder = border;
        }
      }

      selectedBorder = bestBorder;
      console.log(`所有边界已满，使用加权评分选择 ${selectedBorder} 边界`);
    }

    // 更新边界计数
    const positionInBorder = this.borderCardCounts[selectedBorder];
    this.borderCardCounts[selectedBorder]++;

    // 6. 在选定边界上按投影位置智能排列
    let finalX, finalY;

    switch(selectedBorder) {
      case 'right': // 右边界 - 放置在地图内部右侧
        finalX = mapBounds.maxLng - borderMargin - cardWidthOffset;
        // 垂直分布，考虑投影位置
        const rightHeight = mapBounds.maxLat - mapBounds.minLat - 2 * borderMargin - 2 * cardHeightOffset;
        const rightSpacing = rightHeight / Math.max(1, maxCardsPerBorder);
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset + positionInBorder * rightSpacing;
        break;

      case 'bottom': // 下边界 - 放置在地图内部下侧
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset;
        // 水平分布，考虑投影位置
        const bottomWidth = mapBounds.maxLng - mapBounds.minLng - 2 * borderMargin - 2 * cardWidthOffset;
        const bottomSpacing = bottomWidth / Math.max(1, maxCardsPerBorder);
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset + positionInBorder * bottomSpacing;
        break;

      case 'left': // 左边界 - 放置在地图内部左侧
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset;
        // 垂直分布，考虑投影位置
        const leftHeight = mapBounds.maxLat - mapBounds.minLat - 2 * borderMargin - 2 * cardHeightOffset;
        const leftSpacing = leftHeight / Math.max(1, maxCardsPerBorder);
        finalY = mapBounds.minLat + borderMargin + cardHeightOffset + positionInBorder * leftSpacing;
        break;

      case 'top': // 上边界 - 放置在地图内部上侧
        finalY = mapBounds.maxLat - borderMargin - cardHeightOffset;
        // 水平分布，考虑投影位置
        const topWidth = mapBounds.maxLng - mapBounds.minLng - 2 * borderMargin - 2 * cardWidthOffset;
        const topSpacing = topWidth / Math.max(1, maxCardsPerBorder);
        finalX = mapBounds.minLng + borderMargin + cardWidthOffset + positionInBorder * topSpacing;
        break;
    }

    // 7. 边界约束检查，确保卡片在地图范围内，增加额外安全边距
    const extraSafetyMargin = 0.0; // 额外安全边距（减小以让卡片更贴近边界）
    finalX = Math.max(mapBounds.minLng + borderMargin + cardWidthOffset + extraSafetyMargin,
                     Math.min(finalX, mapBounds.maxLng - borderMargin - cardWidthOffset - extraSafetyMargin));
    finalY = Math.max(mapBounds.minLat + borderMargin + cardHeightOffset + extraSafetyMargin,
                     Math.min(finalY, mapBounds.maxLat - borderMargin - cardHeightOffset - extraSafetyMargin));

    // 8. 连线交叉检测和微调（简化版）
    // 检查是否与其他卡片位置冲突，如有冲突则微调
    const minDistance = 0.01; // 最小卡片间距
    if (allDotPositions && allDotPositions.length > 0) {
      for (let i = 0; i < index; i++) {
        const otherPos = allDotPositions[i];
        if (otherPos && otherPos.cardPosition) {
          const distance = Math.sqrt(
            Math.pow(finalX - otherPos.cardPosition[0], 2) +
            Math.pow(finalY - otherPos.cardPosition[1], 2)
          );
          if (distance < minDistance) {
            // 微调位置避免重叠
            if (selectedBorder === 'right' || selectedBorder === 'left') {
              finalY = finalY + minDistance; // 垂直微调
            } else {
              finalX = finalX + minDistance; // 水平微调
            }
          }
        }
      }
    }

    // 计算相对于圆点的偏移量
    const offsetX = finalX - lng;
    const offsetY = finalY - lat;

    console.log(`卡片 ${index} 智能分配到 ${selectedBorder} 边界 (位置 ${positionInBorder})`);
    console.log(`  圆点位置: lng=${lng.toFixed(6)}, lat=${lat.toFixed(6)}`);
    console.log(`  最终位置: lng=${finalX.toFixed(6)}, lat=${finalY.toFixed(6)}`);
    console.log(`  偏移量: x=${offsetX.toFixed(6)}, y=${offsetY.toFixed(6)}`);
    console.log(`  边界计数:`, this.borderCardCounts);

    return {
      x: offsetX,
      y: offsetY,
      boundary: selectedBorder
    };
  },

  // 获取卡片实际尺寸（通过DOM渲染获取真实尺寸）
  getCardDimensions(cardContent) {
    try {
      // 创建临时容器来测量实际尺寸
      const tempContainer = document.createElement('div');
      tempContainer.style.position = 'absolute';
      tempContainer.style.visibility = 'hidden';
      tempContainer.style.top = '-9999px';
      tempContainer.style.left = '-9999px';
      tempContainer.style.pointerEvents = 'none';

      // 设置卡片内容
      tempContainer.innerHTML = cardContent;

      // 添加到页面中进行渲染
      document.body.appendChild(tempContainer);

      // 获取实际渲染尺寸
      const rect = tempContainer.getBoundingClientRect();
      const actualWidth = Math.ceil(rect.width) || 348; // 如果获取失败使用默认值
      const actualHeight = Math.ceil(rect.height) || 200;

      // 清理临时元素
      document.body.removeChild(tempContainer);

      // 判断是否为待出让土地（包含"待出让"字样）
      const isWaitingLand = cardContent.includes('待出让');

      console.log(`卡片真实尺寸: 类型=${isWaitingLand ? '待出让' : '已成交'}, 实际宽度=${actualWidth}px, 实际高度=${actualHeight}px`);

      return {
        width: actualWidth,
        height: actualHeight
      };
    } catch (error) {
      console.error('获取卡片真实尺寸失败，使用默认尺寸:', error);
      // 如果DOM操作失败，回退到基础尺寸
      return {
        width: 348,
        height: 200
      };
    }
  },

  // 调试：显示卡片边界框（可选）
  showCardBounds(currentMap, cardPosition, cardDimensions) {
    if (!this.debugMode) return;

    const pixelToLngLat = 0.0001;
    const widthOffset = (cardDimensions.width / 2) * pixelToLngLat;
    const heightOffset = (cardDimensions.height / 2) * pixelToLngLat;

    const bounds = [
      [cardPosition[0] - widthOffset, cardPosition[1] - heightOffset],
      [cardPosition[0] + widthOffset, cardPosition[1] + heightOffset]
    ];

    const rectangle = new AMap.Rectangle({
      bounds: bounds,
      strokeColor: "#FF0000",
      strokeWeight: 1,
      strokeStyle: "dashed",
      fillColor: "#FF0000",
      fillOpacity: 0.1
    });

    rectangle.setMap(currentMap);
  },

  // 调试：显示圆点保护区域（可选）
  showDotProtectionZones(currentMap, allDotPositions) {
    if (!this.debugMode) return;

    for (let dotPos of allDotPositions) {
      const circle = new AMap.Circle({
        center: [dotPos.lng, dotPos.lat],
        radius: 0.02, // 保护半径
        strokeColor: "#00FF00",
        strokeWeight: 1,
        strokeStyle: "dashed",
        fillColor: "#00FF00",
        fillOpacity: 0.1
      });

      circle.setMap(currentMap);
    }
  },

  // 调试：显示地图中心点和方向线（可选）
  showMapCenterAndDirections(currentMap, allDotPositions) {
    if (!this.debugMode) return;

    const mapCenter = { lng: 120.128847, lat: 30.223938 };

    // 显示地图中心点
    const centerMarker = new AMap.Marker({
      position: [mapCenter.lng, mapCenter.lat],
      content: '<div style="width:20px;height:20px;background:blue;border-radius:50%;border:2px solid white;"></div>',
      offset: new AMap.Pixel(-10, -10)
    });
    centerMarker.setMap(currentMap);

    // 显示从中心到每个圆点的方向线
    for (let dotPos of allDotPositions) {
      const polyline = new AMap.Polyline({
        path: [[mapCenter.lng, mapCenter.lat], [dotPos.lng, dotPos.lat]],
        strokeColor: "#0000FF",
        strokeWeight: 1,
        strokeStyle: "dashed",
        strokeOpacity: 0.5
      });
      polyline.setMap(currentMap);
    }
  },

  getLandmarks(map) {
    let that = this;
    that.$axios
      .get(that.$url_prefix + "getLandmarks", {
        params: {
          center: that.realLngLat,
        },
      })
      .then((res) => {
        let list = res.data.data;
        let len = list.length;
        if (len === 0) {
          that.$message.error("范围内没有地标");
        } else {
          for (let i = 0; i < len; i++) {
            if (!list[i].area) {
              that.$message.error("没有板块");
              continue;
            }
            let position = list[i].position;
            let areaStr =
              list[i].area.district + "|" + list[i].area.area_name;
            let markerContent = `
              <div class="oldPrice">
                <div class="realPrice-c">${areaStr}</div>
                <div class="realPrice-c">${list[i].location_name}</div>
              </div>
              `;
            let nameLen = Math.max(
              list[i].location_name.length,
              areaStr.length
            );
            let offsetX = -nameLen * 5;
            let marker = new AMap.Marker({
              position: position,
              content: markerContent,
              offset: new AMap.Pixel(offsetX, -10),
            });
            marker.setMap(map);

            let circle = new AMap.Circle({
              center: position,
              radius: 5000,
              fillColor: "#000000",
              strokeColor: "#000000",
              strokeOpacity: 0.3,
              fillOpacity: 0.3,
            });
            circle.setMap(map);
          }
          let markerContent = `
            <div class="areaName">
              <div class="realPrice-c">本楼盘</div>
            </div>
            `;
          let marker = new AMap.Marker({
            position: that.realLngLat.split("-")[0].split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-15, -10),
          });
          marker.setMap(map);
        }
      })
      .catch((res) => {
        console.log("get landmarks fail", res);
      });
  },
}



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindUtils.js